/**
 * Component for the application background
 * Component used to render the app background color, gradient and art image
 *
 * @module components
 */

import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { AppBgKeys, BgThemes } from '../../constants/App';
import { getInDomain } from '../../domains/externalUtils';
import { getArt, isColorDark } from '../../lib/ArtUtils';
import { getAppBg, getCurrentDominantColor, getIsSessionHistoryOpen } from '../../lib/UIStateUtils';
import colors from '../../sass/definitions/_colors.scss';
import BlurredBackground from '../BlurredBackground/BlurredBackground';

import './AppBg.scss';

export class AppBg extends React.Component {
  static propTypes = {
    bgTheme: PropTypes.string,
    nowPlayingArtBg: PropTypes.string,
    isRightRailActive: PropTypes.bool,
    dominantColor: PropTypes.string,
    isSessionHistoryOpen: PropTypes.bool,
    isBackgroundDark: PropTypes.bool,
  };

  renderBg = () => {
    let bgColor = null;
    let bgImage = null;
    let bgType = null;

    switch (this.props.bgTheme) {
      case BgThemes.WHITE: {
        bgColor = '#FFFFFF';
        bgType = 'solid';
        break;
      }
      case BgThemes.IMG: {
        bgColor = this.props.dominantColor || colors.colorBlueElectric;
        bgImage = this.props.nowPlayingArtBg;
        bgType = 'img';
        break;
      }
      default: {
        bgType = 'linearGradient';
        break;
      }
    }

    return (
      <div>
        <BlurredBackground
          backgroundColor={bgColor}
          backgroundImage={bgImage}
          backgroundType={bgType}
        />
      </div>
    );
  };

  render() {
    return <div className='AppBg'>{this.renderBg()}</div>;
  }
}

export function mapStateToProps(state) {
  const bgTheme = getAppBg(state).get(AppBgKeys.BG_THEME);
  const dominantColor = getCurrentDominantColor(state);
  const isBackgroundDark = isColorDark(dominantColor);
  const nowPlayingTrack = getInDomain(
    'playback.utils.getCurrentTrackFromActivePlaylist',
    null,
  )(state);
  const isRightRailActive = getInDomain('ads.utils.getIsRightRailActive', false)(state);
  const isSessionHistoryOpen = getIsSessionHistoryOpen(state);
  let nowPlayingArtBg = null;

  if (nowPlayingTrack) {
    nowPlayingArtBg = getArt(nowPlayingTrack, 500, state);
  }

  return {
    nowPlayingArtBg,
    isRightRailActive,
    isSessionHistoryOpen,
    bgTheme,
    dominantColor,
    isBackgroundDark,
  };
}

export default connect(mapStateToProps)(AppBg);
